export function doRequest(url: string) {
    const request = new XMLHttpRequest();
    request.open('GET', url);
    request.send();
}
